import { rest } from 'msw'

import { VendorTypes } from '../../entities/enums/VendorTypeEnum'
import { VendorApiModelStub } from '../api-models/stubs/VendorApiModel.stub'
import { type VendorApiModel } from '../api-models/VendorApiModel'

// Inline provider creation from CreditCardProviderSelect (BHV-018) —
// POST /api/v3/vendors/ with { name, email: [], type: 6 }.
export const mockCreateCreditCardProviderSuccess = (
  params: Partial<VendorApiModel> = {}
) => {
  return rest.post(`/api/v3/vendors/`, (req, res, ctx) => {
    const body = req.body as { name?: string }
    const data = VendorApiModelStub.build({
      type: VendorTypes.CREDIT_CARD_PROVIDER,
      ...(body?.name ? { name: body.name } : {}),
      ...params,
    })

    return res.once(ctx.status(201), ctx.json({ data }))
  })
}
